<template>
  <span class="inline-block h-[12px] w-[12px] rounded-full bg-primary" />
</template>
